let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("e2ujj"), load("fmD6y")]).then(() => parcelRequire('8ysYv'));